import { render, staticRenderFns } from "./Invitar.vue?vue&type=template&id=ae473454"
import script from "./Invitar.vue?vue&type=script&lang=js"
export * from "./Invitar.vue?vue&type=script&lang=js"
import style0 from "./Invitar.vue?vue&type=style&index=0&id=ae473454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports